import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import s from "../add_form/recap.scss";
import Button from "Components/button/Button";
import { t } from "i18next";
import TranslatedString from "Components/TranslatedString";
import currency from "currency.js";

export default class RecapStep extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      total: this.calcTotal()
    };
  }

  calcTotal = () => {
    let total = 0;

    this.props.upgradingDomains.forEach(d => {
      total = currency(total).add(d.estimate);
    });

    return total;
  };

  render() {
    const { upgradingDomains, isAddingDomain, upgrading, submitForm, prices, action } = this.props;
    const { total } = this.state;

    return (
      <div className="orderPage">
        {React.cloneElement(this.props.stepper, {
          ...this.props.stepper.props,
          goBack: () => this.props.goToStep(1)
        })}
        <div className={cx("sectionTitle", "titleFP")}>{t("order.add.title.step6")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP"></div>

          <div className="wrapFormsFP">
            <div className="formsFP">
              {upgradingDomains.map(d => {
                return (
                  <div className={cx("inputFull2", s.bill)} key={d.name}>
                    <div className={cx(s.headerService, s.rowService)}>
                      <div className={s.nameService}> {d.name}</div>
                    </div>

                    {(action === "plan_upgrade" || action === "add_domain") && (
                      <div className={s.rowService}>
                        <div className={s.nameService}>{t("table.header.plan")}</div>
                        <div className={s.dataService}>
                          <div className={s.numberService}>{d.new_plan}</div>
                        </div>
                      </div>
                    )}

                    {(action === "add_emails" || action === "add_domain") && (
                      <>
                        <div className={s.rowService}>
                          <div className={s.nameService}>
                            {t("detailInfo.label.emailAccounts8gb")}
                          </div>
                          <div className={s.dataService}>
                            <div className={s.numberService}>{d.new_8_count}</div>
                            <div className={s.priceService}>
                              {prices.annually[`${d.new_plan}_8`]}
                            </div>
                          </div>
                        </div>

                        <div className={s.rowService}>
                          <div className={s.nameService}>
                            {t("detailInfo.label.emailAccounts25gb")}
                          </div>
                          <div className={s.dataService}>
                            <div className={s.numberService}>{d.new_25_count}</div>
                            <div className={s.priceService}>
                              {prices.annually[`${d.new_plan}_25`]}
                            </div>
                          </div>
                        </div>

                        <div className={s.rowService}>
                          <div className={s.nameService}>{t("detailInfo.label.archive")}</div>
                          <div className={s.dataService}>
                            <div className={s.numberService}>{d.new_archive_count}</div>
                            <div className={s.priceService}>
                              {prices.annually[`${d.new_plan}_vault`]}
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    <div className={cx("inputFull2", s.rowBill)}>
                      <div className={s.fee}>
                        <div>{t("order.label.first.bill.annual")}</div>

                        {isAddingDomain ? (
                          <div className={s.priceFee}>{d.estimate}</div>
                        ) : (
                          <div className={s.priceFee}>{this.props.estimate}</div>
                        )}
                      </div>

                      <div className={s.infoFee}>
                        * <TranslatedString>infoMsg.priceVat</TranslatedString>
                      </div>
                    </div>
                  </div>
                );
              })}

              {isAddingDomain && (
                <div className={cx("inputFull2", s.rowBill)}>
                  <div className={s.fee}>
                    <div>{t("order.label.first.bill.annualTotal")}</div>

                    <div className={s.priceFee}>{total.format()}</div>
                  </div>

                  <div className={s.infoFee}>
                    * <TranslatedString>infoMsg.priceVat</TranslatedString>
                  </div>
                </div>
              )}
            </div>

            <div className="footerFP">
              <Button
                onClick={this.props.backToList}
                type="button"
                color="text"
                disabled={upgrading}
              >
                button.cancel
              </Button>
              <Button type="submit" color="green" onClick={submitForm} loading={upgrading}>
                button.order
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

RecapStep.contextTypes = {
  router: PropTypes.object,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func
};
